const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29809_110026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C6.5878 11 7.65117 10.6774 8.55564 10.0731C9.46011 9.46874 10.1651 8.60975 10.5813 7.60476C10.9976 6.59977 11.1065 5.4939 10.8943 4.42701C10.6821 3.36011 10.1583 2.3801 9.38909 1.61092C8.6199 0.841726 7.63989 0.317902 6.573 0.105683C5.5061 -0.106535 4.40023 0.00238307 3.39524 0.418665C2.39025 0.834947 1.53126 1.5399 0.926917 2.44437C0.322569 3.34884 0 4.41221 0 5.5C0.00157716 6.95821 0.581546 8.35624 1.61265 9.38735C2.64376 10.4185 4.04179 10.9984 5.5 11ZM5.5 2.29167C5.63597 2.29167 5.7689 2.33199 5.88195 2.40753C5.99501 2.48308 6.08313 2.59045 6.13517 2.71607C6.1872 2.8417 6.20082 2.97993 6.17429 3.11329C6.14776 3.24666 6.08228 3.36916 5.98614 3.4653C5.88999 3.56145 5.76749 3.62693 5.63412 3.65346C5.50076 3.67999 5.36253 3.66637 5.23691 3.61434C5.11128 3.5623 5.00391 3.47418 4.92836 3.36112C4.85282 3.24806 4.8125 3.11514 4.8125 2.97917C4.8125 2.79683 4.88493 2.62196 5.01386 2.49303C5.1428 2.3641 5.31766 2.29167 5.5 2.29167ZM5.04167 4.58334H5.5C5.74312 4.58334 5.97627 4.67991 6.14818 4.85182C6.32009 5.02373 6.41667 5.25689 6.41667 5.5V8.25C6.41667 8.37156 6.36838 8.48814 6.28242 8.57409C6.19647 8.66005 6.07989 8.70834 5.95833 8.70834C5.83678 8.70834 5.7202 8.66005 5.63424 8.57409C5.54829 8.48814 5.5 8.37156 5.5 8.25V5.5H5.04167C4.92011 5.5 4.80353 5.45171 4.71758 5.36576C4.63162 5.27981 4.58333 5.16323 4.58333 5.04167C4.58333 4.92011 4.63162 4.80353 4.71758 4.71758C4.80353 4.63162 4.92011 4.58334 5.04167 4.58334Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29809_110026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackIcon);
export default __webpack_public_path__ + "static/media/blackIcon.15de88384acd8c10be49263582cd1a9f.svg";
export { ForwardRef as ReactComponent };